import ko from './ko.json';
import en from './en.json';
import zh_CN from './zh_CN.json';
import zh_TW from './zh_TW.json';
import ja from './ja.json';
import fr from './fr.json';
import de from './de.json';
import mn from './mn.json';

export const messages = {
  ko,
  en,
  zh_CN,
  zh_TW,
  ja,
  fr,
  de,
  mn
};

export const DEFAULT_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['ko', 'en', 'zh_CN', 'zh_TW', 'ja', 'fr', 'de', 'mn'];
export const LANGUAGE_NAMES = {
  ko: '한국어',
  en: 'English',
  zh_CN: '简体中文',
  zh_TW: '繁體中文',
  ja: '日本語',
  fr: 'Français',
  de: 'Deutsch',
  mn: 'Монгол'
};
export const LANGUAGE_FLAGS = {
  ko: '🇰🇷',
  en: '🇺🇸',
  zh_CN: '🇨🇳',
  zh_TW: '🇹🇼',
  ja: '🇯🇵',
  fr: '🇫🇷',
  de: '🇩🇪',
  mn: '🇲🇳'
};
